import { SelectionModel } from '@angular/cdk/collections';
import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, input, ViewChild } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { RouterModule } from '@angular/router';
import { TableColumn } from './table';

@Component({
  selector: 'app-table',
  imports: [
    // App modules
    CommonModule,
    ReactiveFormsModule,
    RouterModule,

    // Material modules
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatCheckboxModule,
  ],
  templateUrl: './table.component.html',
  styleUrl: './table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableComponent implements AfterViewInit {

  @ViewChild(MatSort) sort!: MatSort;

  displayedColumns = input<TableColumn[]>([]);

  dataSource = new MatTableDataSource<unknown>();

  selection = new SelectionModel<unknown>(true, []);

  pageSizeOptions = DEFAULT_PAGES;

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
  }

  masterToggle(): void {
    if (this.isAllSelected()) {
      this.selection.clear()
    } else {
      this.dataSource.data.forEach(row => {
        // @ts-ignore
        if (row?.['status'] !== 'Inactive') {
          this.selection.select(row);
        }
      });
    }
  }

  checkRow(row: unknown) {
    this.selection.toggle(row)
  }

  isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }


}

const DEFAULT_PAGES = [25];

// export interface TableColumn {
//   label: string;
//   key: string;
// }